module.exports = __webpack_public_path__ + "img/sqxx_xz.4ea67156.png";